export enum SignalRMethod {
    AddToGroupAsync = 'AddToGroupAsync',
    ReceiveSessionNotification = 'ReceiveSessionNotification',
}